/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module WafModule
 */

import { Injector } from '@angular/core';

import {
    LatestWafCrsVersionService,
} from 'ajs/modules/waf/services/latest-waf-crs-version.service';

import {
    WafProfileCollection,
} from 'ajs/modules/waf/factories/waf-profile/waf-profile.collection.factory';

import {
    WafPolicyCollection,
} from 'ajs/modules/waf/factories/waf-policy/waf-policy.collection.factory';

import {
    WafPolicyCloneableItem,
    WafPolicyItem,
} from 'ajs/modules/waf/factories/waf-policy/waf-policy.item.factory';

import {
    LATEST_WAF_CRS_VERSION_SERVICE_TOKEN,
    WAF_POLICY_CLONEABLE_ITEM_TOKEN,
    WAF_POLICY_COLLECTION_TOKEN,
    WAF_POLICY_ITEM_TOKEN,
    WAF_PROFILE_COLLECTION_TOKEN,
} from 'ajs/modules/waf/waf.tokens';

const $injector = '$injector';

export const wafProfileCollectionProvider = {
    deps: [$injector],
    provide: WafProfileCollection,
    useFactory(injector: Injector): typeof WafProfileCollection {
        return injector.get(WAF_PROFILE_COLLECTION_TOKEN);
    },
};

export const latestWafCrsVersionServiceProvider = {
    deps: [$injector],
    provide: LatestWafCrsVersionService,
    useFactory(injector: Injector): LatestWafCrsVersionService {
        return injector.get(LATEST_WAF_CRS_VERSION_SERVICE_TOKEN);
    },
};

export const wafPolicyCollectionProvider = {
    deps: [$injector],
    provide: WafPolicyCollection,
    useFactory(injector: Injector): typeof WafPolicyCollection {
        return injector.get(WAF_POLICY_COLLECTION_TOKEN);
    },
};

export const wafPolicyItemProvider = {
    deps: [$injector],
    provide: WafPolicyItem,
    useFactory(injector: Injector): typeof WafPolicyItem {
        return injector.get(WAF_POLICY_ITEM_TOKEN);
    },
};

export const wafPolicyCloneableItemProvider = {
    deps: [$injector],
    provide: WafPolicyCloneableItem,
    useFactory(injector: Injector): typeof WafPolicyCloneableItem {
        return injector.get(WAF_POLICY_CLONEABLE_ITEM_TOKEN);
    },
};
